import { render, staticRenderFns } from "./PC.vue?vue&type=template&id=6d4d071e&scoped=true&"
import script from "./PC.vue?vue&type=script&lang=js&"
export * from "./PC.vue?vue&type=script&lang=js&"
import style0 from "./PC.vue?vue&type=style&index=0&id=6d4d071e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4d071e",
  null
  
)

export default component.exports